import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ArquitectosDeCabecera from './views/ArquitectosDeCabecera.vue';
import LaGranja from './views/LaGranja.vue';
import ClasesDeIngles from './views/ClasesDeIngles.vue';
import Torolab from './views/Torolab.vue';
import CocoClub from './views/CocoClub.vue';
import ComedorVictoria from './views/ComedorVictoria.vue';
import ElKiosko from './views/ElKiosko.vue';
import FantasyFarm from './views/FantasyFarm.vue';
import Fronteras from './views/Fronteras.vue';
import Futbol from './views/Futbol.vue';
import GhanaThinkTank from './views/GhanaThinkTank.vue';
import Navego from './views/Navego.vue';
import Redes2025 from './views/Redes2025.vue';
import ThinkFarm from './views/ThinkFarm.vue';
import UrbInt from './views/UrbInt.vue';
import VidaEnVerde from './views/VidaEnVerde';
import Liisa from './views/Liisa';
import AboutGranja from './views/AboutGranja';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/la-granja',
      name: 'la-granja',
      component: LaGranja
    },
    {
      path: '/torolab',
      name: 'torolab',
      component: Torolab
    },
    {
      path: '/liisa',
      name: 'liisa',
      component: Liisa
    },
    {
      path: '/acerca-la-granja',
      name: 'acerca-la-granja',
      component: AboutGranja
    },
    {
      path: '/arquitectos-de-cabecera',
      name: 'arquitectos-de-cabecera',
      component: ArquitectosDeCabecera
    },
    {
      path: '/clases-de-ingles',
      name: 'clases-de-ingles',
      component: ClasesDeIngles
    },
    {
      path: '/cococlub',
      name: 'coco-club',
      component: CocoClub
    },
    {
      path: '/comedor-victoria',
      name: 'comedor-victoria',
      component: ComedorVictoria
    },
    {
      path: '/el-kiosko',
      name: 'el-kiosko',
      component: ElKiosko
    },
    {
      path: '/fantasy-farm',
      name: 'fantasy-farm',
      component: FantasyFarm
    },
    {
      path: '/fronteras',
      name: 'fronteras',
      component: Fronteras
    },
    {
      path: '/futbol',
      name: 'futbol',
      component: Futbol
    },
    {
      path: '/ghanathinktank',
      name: 'ghanathinktank',
      component: GhanaThinkTank
    },
    {
      path: '/navego',
      name: 'navego',
      component: Navego
    },
    {
      path: '/redes2025',
      name: 'redes2025',
      component: Redes2025
    },
    {
      path: '/thinkfarm',
      name: 'thinkfarm',
      component: ThinkFarm
    },
    {
      path: '/urbint',
      name: 'urbint',
      component: UrbInt
    },
    {
      path: '/vida-en-verde',
      name: 'vida-en-verdel',
      component: VidaEnVerde
    }
  ]
});
